/**
 * Hands the browser a file it did not ask for over the network: an `<a
 * download>` clicked by code instead of a person, for a zip built entirely in
 * memory. Shared by the Stage 4 listing screen (one item's photos) and the
 * Stage 5 export screen (everything).
 */
export function downloadBlob(blob: Blob, name: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  document.body.append(link);
  link.click();
  link.remove();
  // Revoked on the next turn: revoking synchronously can cancel the download.
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
